import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import MusicPlayer from "@/components/MusicPlayer";
import VideoSection from "@/components/VideoSection";
import Tracklist from "@/components/Tracklist";
import AboutArtist from "@/components/AboutArtist";
import Gallery from "@/components/Gallery";
import PreorderSection from "@/components/PreorderSection";
import Socials from "@/components/Socials";
import AdminPanel from "@/components/AdminPanel";

function NoiseOverlay() {
  return (
    <div className="noise-overlay">
      <svg>
        <filter id="noiseFilter">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.65"
            numOctaves="3"
            stitchTiles="stitch"
          />
        </filter>
        <rect width="100%" height="100%" filter="url(#noiseFilter)" />
      </svg>
    </div>
  );
}

function LandingPage() {
  return (
    <div className="relative min-h-screen bg-black text-white">
      <NoiseOverlay />
      <Navigation />
      <main>
        <HeroSection />
        <MusicPlayer />
        <VideoSection />
        <Tracklist />
        <AboutArtist />
        <Gallery />
        <PreorderSection />
        <Socials />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
